import React from "react";

import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import { IconProps } from "@mui/material";
import { HorizontalNavBar } from "components";
import { Routes } from "constants/routes";
import { useAccountSelector } from "store";

interface Props {
  value: "performance" | "liquidity" | "telescope" | "correlation";
  onChange: (value: Props["value"]) => void;
}

const iconsSx: IconProps["sx"] = {
  fontSize: "16px",
  mr: "6px"
};

export const Tabs: React.FC<Props> = ({ onChange }) => {
  const { show_telescope } = useAccountSelector() || {};

  return (
    <HorizontalNavBar
      tabs={[
        {
          value: "performance",
          label: "Performance",
          icon: <GridViewOutlinedIcon sx={iconsSx} />,
          onClick: () => onChange("performance"),
          matchRouts: [Routes.benchmarkPerformance]
        },
        {
          value: "liquidity",
          label: "Liquidity Profile",
          icon: <InsertChartOutlinedIcon sx={iconsSx} />,
          onClick: () => onChange("liquidity"),
          matchRouts: [Routes.benchmarkLiquidity]
        },
        {
          value: "correlation",
          label: "Correlation Matrix",
          icon: <AnalyticsOutlinedIcon sx={iconsSx} />,
          onClick: () => onChange("correlation"),
          matchRouts: [Routes.benchmarkCorrelation]
        },
        {
          value: "telescope",
          label: "Altius Telescope",
          icon: <LocationCityIcon sx={iconsSx} />,
          onClick: () => onChange("telescope"),
          matchRouts: [Routes.benchmarkTelescope],
          hidden: !show_telescope
        }
      ]}
    />
  );
};
